<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-calendar"></i> {{$t('pages.clearData.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="container">
        <div class="form-box">
            <el-form ref="form" :model="form" label-width="80px">
                <el-alert :title="$t('pages.clearData.alert')" type="error" center :closable="false" effect="dark"></el-alert>
                <br />
                <br />
                <el-form-item :label="$t('pages.clearData.scale')">
                    <el-select v-model="form.balanceId" :placeholder="$t('pages.clearData.selectPh')">
                        <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('pages.clearData.type')">
                    <el-radio-group v-model="form.operaType">
                        <el-radio key="仅清空电脑数据" label="仅清空电脑数据">{{$t('pages.clearData.radio.pcOnly')}}</el-radio>
                        <el-radio key="仅清空仪表数据" label="仅清空仪表数据">{{$t('pages.clearData.radio.meterOnly')}}</el-radio>
                        <el-radio key="清空电脑及仪表数据" label="清空电脑及仪表数据">{{$t('pages.clearData.radio.both')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{$t('pages.clearData.submit')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import {
    SortField
} from '../../utils/helper';
export default {
    name: 'clearData',
    data() {
        return {
            balanceArr: [],
            form: {
                balanceId: '',
                operaType: '仅清空电脑数据'
            }
        };
    },

    created() {
        this.getBalance();
    },
    methods: {
        onSubmit() {
            if (this.form.balanceId == '') {
                this.$notify.warning(this.$t('pages.clearData.warn.selectScale'));
                return;
            }
            this.$confirm(this.$t('pages.clearData.confirmClear'), this.$t('pages.clearData.tip'), {
                    type: 'warning'
                })
                .then(() => {
                    this.$zybhttp
                        .get('DataInquiry/ClearData', {
                            params: {
                                balanceId: this.form.balanceId,
                                operaType: this.form.operaType
                            }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(res.data.msg);
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.clearData.opError')));
                })
                .catch(() => {});
        },
        getBalance() {
            var serach = {};
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = d.sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.clearData.fetchError')));
        }
    }
};
</script>
